import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    schedules: [],
    scheduleFilters: [],

    schedulePage: {
      inputType: 'perDay',
      inputTemplate: {
        template: [],
        withoutServices: false,
        visitingDay: false,
      },
      showModal: false,
      selectedItemData: {},
    },
    scheduleStatistic: {},
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
